<!-- Formulario de login con locator + código -->
<ng-container *ngIf="!showBook">
  <div class="w-100 h-100 d-flex justify-content-center align-items-center"
    style="position:absolute;top:0;left:0; z-index: 999; background-color: rgba(139, 139, 139, 0.486);"
    *ngIf='showSpinner'>
    <div class="spinner-border text-light" role="status">
    </div>
    <span class="ms-3">Loading...</span>
  </div>
  <div class="w-100 h-100" *ngIf="!globalVariables.isPageSmall" [innerHTML]='html_desktop'>
  </div>

  <div class="w-100 h-100" *ngIf="globalVariables.isPageSmall" [innerHTML]='html_mobile'>
  </div>
</ng-container>

<!-- Visor del Book (tras autenticación o con auto-auth params) -->
<app-book-pdf-flipbook *ngIf="showBook"></app-book-pdf-flipbook>

<app-access-selection-popup></app-access-selection-popup>